/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Info_seller = {
    readonly sellerProfile: {
        readonly company: string | null;
    } | null;
    readonly " $refType": "Info_seller";
};
export type Info_seller$data = Info_seller;
export type Info_seller$key = {
    readonly " $data"?: Info_seller$data;
    readonly " $fragmentRefs": FragmentRefs<"Info_seller">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Info_seller",
  "type": "Seller",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "sellerProfile",
      "storageKey": null,
      "args": null,
      "concreteType": "SellerProfile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "company",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = 'dbc0fbd5fd54c33d049ccb69e1f04d7a';
export default node;
